import React from 'react';
import styles from './ButtonLink.module.css';

export type ButtonLinkProps = {
  isScrolled?: boolean;
  size?: 's' | 'm';
  as?: any;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  ({ as, isScrolled, size = 's', className, ...rest }, ref) => {
    const Tag: any = as || 'a';
    const cls = [
      styles.root,
      !isScrolled && styles.notScrolled,
      size === 'm' && styles.sizeM,
      className,
    ]
      .filter(Boolean)
      .join(' ');
    return <Tag ref={ref} className={cls} {...rest} />;
  },
);

ButtonLink.displayName = 'ButtonLink';

export const BlurredButtonLink = React.forwardRef<
  HTMLAnchorElement,
  ButtonLinkProps
>(({ className, ...rest }, ref) => (
  <ButtonLink
    ref={ref}
    className={[styles.blurred, className].filter(Boolean).join(' ')}
    {...rest}
  />
));

BlurredButtonLink.displayName = 'BlurredButtonLink';
